module.exports = __webpack_public_path__ + "img/ico_talk_user.dd804c64.png";